import React, { useEffect, useRef } from "react";

import scrollToRef from "utils/scrollToRef";

import Question from "./question/question";
import styles from "./feedback-questions.scss";

const FeedbackQuestions = ({ questions, onQuestionAnswered }) => {
	const scrollRef = useRef();

	useEffect(() => {
		if (questions.length > 1) scrollToRef(scrollRef);
	}, [questions]);

	return (
		<div className={styles.feedback_questions}>
			{questions.map((questionConfig, index) => (
				<div key={questionConfig.id}>
					{index === questions.length - 1 && <div ref={scrollRef}></div>}
					<Question questionConfig={questionConfig} onQuestionAnswered={onQuestionAnswered} />
				</div>
			))}
		</div>
	);
};

export default FeedbackQuestions;
